export const RUN_COMMAND_RESPONSE_OPERATIONAL_FORM_FIELD_NAMES = {
  id_form_answer: "id_form_answer",
  reference: "reference",
  id_template: "id_template",
};

export function normalizeIdFormAnswer(raw) {
  if (raw == null) {
    return null;
  }
  if (typeof raw === "number" && !Number.isNaN(raw)) {
    return raw;
  }
  if (typeof raw === "string" && raw.trim() !== "") {
    const asNumber = Number(raw);
    if (!Number.isNaN(asNumber)) {
      return asNumber;
    }
    return raw;
  }
  return null;
}

function pickNestedPayload(body) {
  if (!body || typeof body !== "object") {
    return null;
  }
  const first = body.data;
  if (!first || typeof first !== "object") {
    return null;
  }
  if (first.id_form_answer != null) {
    return first;
  }
  const second = first.data;
  if (second && typeof second === "object" && second.id_form_answer != null) {
    return second;
  }
  return null;
}

export function extractResponseFormAnswerFromRunCommand(responseBody) {
  const nested = pickNestedPayload(responseBody);
  const source =
    nested != null
      ? nested
      : responseBody && typeof responseBody === "object" && responseBody.id_form_answer != null
        ? responseBody
        : null;
  if (!source) {
    return null;
  }
  const id_form_answer = normalizeIdFormAnswer(source.id_form_answer);
  if (id_form_answer == null) {
    return null;
  }
  const reference =
    source.reference != null && String(source.reference).trim() !== ""
      ? String(source.reference)
      : "";
  const id_template = source.id_template;
  const out = {
    id_form_answer,
    reference,
  };
  if (id_template != null) {
    out.id_template = id_template;
  }
  return out;
}
